'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ApiClient = require('../../helpers/ApiClient');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    (0, _classCallCheck3.default)(this, Login);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Login).apply(this, arguments));
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var styles = require('./Login.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.loginPage + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
        _react2.default.createElement(
          'h1',
          null,
          'Login'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            { className: 'btn btn-success', onClick: function onClick() {
                var redirect_uri = (0, _ApiClient.getApiUrl)() + _config2.default.instagramRedirectURL;
                console.log('instagramRedirectURL:' + redirect_uri);
                window.open('https://api.instagram.com/oauth/authorize/?client_id=' + _config2.default.instagramClientID + '&redirect_uri=' + redirect_uri + '&response_type=code');
              } },
            _react2.default.createElement('i', { className: 'fa fa-sign-in' }),
            'Log In'
          )
        )
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object
}, _temp)) || _class);
exports.default = Login;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Login/Login.js
 ** module id = 1110
 ** module chunks = 0
 **/